import { SolAuthority, SolRequiredAuthorities } from '../services/authorization.service';

export class AuthorizationTools {
  public static hasAuthority(
    authorities: SolAuthority[],
    requiredAuthorities: SolAuthority | SolRequiredAuthorities,
  ): boolean {
    if (!Array.isArray(requiredAuthorities)) {
      return authorities.includes(requiredAuthorities);
    } else if (!requiredAuthorities || requiredAuthorities.length === 0) {
      return true;
    }

    for (const requiredAuthority of requiredAuthorities) {
      if (Array.isArray(requiredAuthority)) {
        if (!requiredAuthority.some(required => authorities.includes(required))) {
          return false;
        }
      } else if (!authorities.includes(requiredAuthority)) {
        return false;
      }
    }
    return true;
  }
}
